export enum InvoiceStatus {
	PENDING_EMISSION = "pending_emission",
	EMITTED = "emitted",
	PAID = "paid"
}
